<template>
  <div class="ma-xxxl">
    <input type="text" ref="phone" class="ma-xxxl" v-model="phone"/>
    <input type="file" ref="file" class="ma-xxxl"/>
    <wd-row flex>
      <wd-col span="12">
        <wd-button @click="getToken(phone)">获取token</wd-button>
        <wd-button @click="doUpload">上传</wd-button>
      </wd-col>

      {{ msg }}
    </wd-row>
    <wd-popup v-model="show" style="width: 80%;border-radius: 8px;background: #fef3ed" :style="{ 'padding': '24px 8px' }" closable>
      <div style="text-align: center;margin-bottom: 16px;font-weight: bold;color: #fb5946;font-size: 20px">领取失败</div>
      <div style="padding: 0 16px 0 16px">您的号码<span style="color: #2d8ff5"> {{ error }} </span>未开通VoLTE功能，请开通后领取</div>
      <div style="padding: 16px 16px 0 16px;color: #777">开通方式：编辑短信’42010‘发送至”10001“开通VoLte功能</div>
    </wd-popup>

  </div>
</template>

<script>
import {uploadCloudOpenFile} from "@/views/upload/api/uploadCloudOpenFile";
import {Hmacstr} from "@/views/upload/utils/Sign";
import {appSecret} from "@/views/upload/utils/utils";
import {accessToken} from "@/api/tianyi/tianyi.api";

export default {
  name: "FileUploadPage",
  data() {
    return {
      show: true,
      phone: '18099106457',
      accessToken: 'A94D88B51016DAADD7E355D1AEE0B382',
      msg: '',
      error : "18099106457"
    }
  },
  created() {
    this.getToken(this.phone)
  },
  methods: {
    getToken(phone) {
      const timestamp = new Date().getTime()
      const appSignature = Hmacstr("appKey=1130131671201" + "&timestamp=" + timestamp, appSecret).toString().toUpperCase();
      const params = {
        appKey: '1130131671201',
        appSignature: appSignature,
        grantType: "189_passport",
        account: phone + "@189.cn",
        timestamp: timestamp,
      }

      accessToken(params).then(resp => {
        if (resp.accessToken) {
          this.accessToken = resp.accessToken
        }
      })
    },
    doUpload() {
      uploadCloudOpenFile(this.$refs.file.files[0], this.accessToken, (e) => {
        console.log(e)
        this.msg = e.msg
      })
    },
  }
}
</script>

<style>

</style>
